import { defineNuxtRouteMiddleware } from '#app/composables/router';

/**
 * Pages that skips the global private middleware. Use this to mark pages as public.
 */
export default defineNuxtRouteMiddleware(async () => {
	// noop
});
